export const colorToBackgroundClass = {
  olive: 'bg-olive-2',
  punch: 'bg-punch',
  powder: 'bg-powder',
  zest: 'bg-zest',
  slime: 'bg-slime',
  highlighter: 'bg-highlighter',
  paper: 'bg-paper-1',
  rock: 'bg-rock-1',
} as const

export type Color = keyof typeof colorToBackgroundClass

export const colorOptions = [
  {
    label: 'Olive',
    value: 'olive',
  },
  {
    label: 'Highlighter',
    value: 'highlighter',
  },
  {
    label: 'Punch',
    value: 'punch',
  },
  {
    label: 'Zest',
    value: 'zest',
  },
  {
    label: 'Slime',
    value: 'slime',
  },
  {
    label: 'Powder',
    value: 'powder',
  },
  {
    label: 'Paper',
    value: 'paper',
  },
  {
    label: 'Rock',
    value: 'rock',
  },
] as const
